import { useMemo, useState } from 'react';

import { PlacesQuery } from '../../../apollo/__generated__/graphql';
import { useDeletePlaceMutation } from '../../hooks/useDeletePlaceMutation';
import { usePlacesQuery } from '../../hooks/usePlacesQuery';

export type VisibleUsersType = 'ALL' | 'INVALID' | 'VALID';

export const usePlaces = () => {
  const [isCreatePlaceDrawerOpen, setIsCreatePlaceDrawerOpen] =
    useState<boolean>(false);
  const [bedroomsPlaceId, setBedroomsPlaceId] = useState<string | null>(null);
  const [placeToDeleteId, setPlaceToDeleteId] = useState<string | null>(null);
  const [editingPlace, setEditingPlace] = useState<
    PlacesQuery['places'][number] | null
  >(null);

  const onCloseDeleteDialog = () => {
    setPlaceToDeleteId(null);
  };

  const { data: placesData, loading } = usePlacesQuery();
  const { deletePlace } = useDeletePlaceMutation(onCloseDeleteDialog);

  const places = useMemo(() => placesData?.places ?? [], [placesData]);

  const onShowBedrooms = (placeId: string) => {
    setBedroomsPlaceId(placeId);
  };

  const onCreate = () => {
    setIsCreatePlaceDrawerOpen(true);
  };

  const onCloseCreatePlaceDrawer = (createdPlaceId?: string) => {
    setIsCreatePlaceDrawerOpen(false);
    if (createdPlaceId) {
      setBedroomsPlaceId(createdPlaceId);
    }
  };

  const onEditPlace = (place: PlacesQuery['places'][number]) => {
    setEditingPlace(place);
  };

  const onShowDeletePlaceDialog = (eventId: string) => {
    setPlaceToDeleteId(eventId);
  };

  const onCloseDeletePlaceDialog = () => {
    setPlaceToDeleteId(null);
  };

  const onDeletePlace = () => {
    if (placeToDeleteId) {
      deletePlace(placeToDeleteId);
    }
  };

  const onCloseEditPlace = () => {
    setEditingPlace(null);
  };

  const onCloseBedroomsDrawer = () => {
    setBedroomsPlaceId(null);
  };

  return {
    places,
    loading,
    onShowBedrooms,
    onCreate,
    isCreatePlaceDrawerOpen,
    onCloseCreatePlaceDrawer,
    bedroomsPlaceId,
    onEditPlace,
    onShowDeletePlaceDialog,
    placeToDeleteId,
    editingPlace,
    onCloseDeletePlaceDialog,
    onDeletePlace,
    onCloseEditPlace,
    onCloseBedroomsDrawer,
  };
};
